import { defineStore } from 'pinia';

/**
 * App-wide chat attention state. Written by useChatNotifications (mounted in
 * the dashboard shell) and read by the sidebar badge; SchoolChat bumps
 * refreshTick after marking a channel read so the shell re-fetches the
 * unread summary immediately instead of waiting for the next poll.
 */
export const useChatStore = defineStore('chat', () => {
  const totalUnread = ref(0);
  const generalChannelId = ref<string | null>(null);
  const refreshTick = ref(0);

  function setTotalUnread(total: number) {
    totalUnread.value = Math.max(0, total);
  }

  function incrementUnread() {
    totalUnread.value += 1;
  }

  function setGeneralChannelId(id: string | null) {
    generalChannelId.value = id;
  }

  function requestRefresh() {
    refreshTick.value += 1;
  }

  return {
    totalUnread,
    generalChannelId,
    refreshTick,
    setTotalUnread,
    incrementUnread,
    setGeneralChannelId,
    requestRefresh,
  };
});
